import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from './authTokens';

/** Shared RTK Query baseQuery — sends Bearer access + cookies for refresh dual-mode. */
export function createAppBaseQuery(baseUrl = '/api/v1') {
  return fetchBaseQuery({
    baseUrl,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  });
}
